import Auth from '../api/auth';
import {
  clearCookiesOnLogout,
  deleteIndexedDBOnLogout,
} from '../store/utils/api';
import { setupRequestDeduplication } from '../api/requestDeduplicator';

// Stores the server app version from the first API response
let initialAppVersion = null;

const checkAppVersion = response => {
  try {
    const serverVersion = response.headers['x-app-version'];
    if (!serverVersion) return;

    if (!initialAppVersion) {
      initialAppVersion = serverVersion;
      return;
    }

    if (serverVersion !== initialAppVersion) {
      // Server was updated — reload to get new JS assets
      window.location.reload();
    }
  } catch {
    // Never break API calls due to version check
  }
};

const parseErrorCode = error => {
  // Handle 401 Unauthorized errors globally
  if (error?.response?.status === 401) {
    // Check if we're not already on a public page to avoid redirect loops
    const publicPaths = ['/app/login', '/app/auth', '/auth'];
    const isPublicPath = publicPaths.some(path =>
      window.location.pathname.startsWith(path)
    );

    if (!isPublicPath) {
      // Clear all auth data and redirect to login
      deleteIndexedDBOnLogout();
      clearCookiesOnLogout();
      // Note: clearCookiesOnLogout already handles the redirect
      return new Promise(() => {}); // Return a never-resolving promise to stop further processing
    }
  }
  return Promise.reject(error);
};

export default axios => {
  const { apiHost = '' } = window.chatwootConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  // Add Auth Headers to requests if logged in
  if (Auth.hasAuthCookie()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();
    Object.assign(wootApi.defaults.headers.common, {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    });
  }

  // Setup request deduplication for GET requests
  setupRequestDeduplication(wootApi);

  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => {
      checkAppVersion(response);
      return response;
    },
    error => parseErrorCode(error)
  );
  return wootApi;
};
